import * as React from 'react';
import { st, classes } from './TabsNavButton.st.css';
import { isSelectKey } from '../../../common/keyCodes';
export class TabsNavButton extends React.Component {
    constructor() {
        super(...arguments);
        this._onKeyDown = (e) => {
            const { onClick } = this.props;
            if (isSelectKey(e)) {
                onClick();
                return false;
            }
            return undefined;
        };
        this._rootRefCallback = (el) => {
            this._rootRef = el;
        };
    }
    width() {
        return this._rootRef ? this._rootRef.offsetWidth : 0;
    }
    render() {
        const { onClick, children, className } = this.props;
        return (React.createElement("div", { className: st(classes.root, className), onClick: onClick, onKeyDown: this._onKeyDown, tabIndex: -1, "data-hook": this.props['data-hook'], "aria-hidden": true, ref: this._rootRefCallback },
            children,
            React.createElement("div", { className: classes.border })));
    }
}
//# sourceMappingURL=TabsNavButton.js.map